/**
 * Change the professions in the profession dropdown based on the selected profession type.
 */
jQuery(document).ready(function ($) {
	if ( typeof object === 'undefined' ) {
		return;
	}

	var id_profession_types = '#' + object.profession_type_input_id,
		id_profession_field = '#' + object.profession_field_id,
		id_profession_other_field = '#' + object.profession_other_field_id,
		id_professions = '#' + object.profession_input_id;

	$(id_profession_other_field).hide();
	$(id_profession_field).hide();

	display_professions( object );
	display_other( object );

	$(id_profession_types).on('change', function () {
		display_professions(object);
		display_other( object );
	});

	$(id_professions).on('change', function () {
		display_other( object );
	});

	/**
	 * Displays the other profession input field when the profession field is on value 'other'
	 */
	function display_other( object ) {
		var id_profession_other_field = '#' + object.profession_other_field_id,
			id_profession_types = '#' + object.profession_type_input_id,
			id_profession_field = '#' + object.profession_field_id,
			id_professions = '#' + object.profession_input_id;

		if ($(id_profession_types + ' option:selected').text().toLowerCase().indexOf(object.profession_type_other.toLowerCase()) === 0) {
			$(id_profession_field).hide();
		}

		if ($(id_professions + ' option:selected').text().toLowerCase().indexOf(object.profession_other.toLowerCase()) === -1 ) {
			$(id_profession_other_field).hide();
			$(id_profession_other_field + ' input').val('');
		} else {
			$(id_profession_other_field).show();
		}
	}

	/**
	 * Display the right profession that belong to the selected profession type.
	 *
	 * @param object
	 */
	function display_professions(object) {
		var id_profession_types = '#' + object.profession_type_input_id,
			id_professions = '#' + object.profession_input_id,
			profession_other = object.profession_other,
			professions = object.professions,
			default_text = object.default.text;

		var profession_type = $(id_profession_types).val();

		if (profession_type.length <= 0) {
			return;
		}

		var professions_to_display = [];


		$.each(professions, function (index, type) {
			if ($.inArray(profession_type, type.types) >= 0) {
				var profession_to_display = [{
					'text': type.text,
					'value': type.value,
				}];

				professions_to_display.unshift(profession_to_display);
			}
		});

		$(id_professions + ' > option').each(function () {
			$(this).remove();
		});

		if (professions_to_display.length <= 0) {
			return;
		}

		$(professions_to_display).each(function () {
			$(id_professions).prepend($('<option>', {
				value: this[0].value,
				text: this[0].text
			}));
		});

		$(id_professions).prepend($('<option>', {
			value: '',
			text: default_text
		}));

		if (profession_type.indexOf(profession_other.toLowerCase()) === -1) {
			$(id_professions).val($(id_professions + 'option:first').val());
			$(id_profession_field).show();
		}

		$(id_professions).select2();
	}
});
